var map = {
	"./astrics.svg": 274,
	"./burger.svg": 275,
	"./circle-half.svg": 276,
	"./circle-quarter.svg": 277,
	"./close.svg": 278,
	"./cross.svg": 279,
	"./facebook.svg": 280,
	"./icon-arrow.svg": 281,
	"./icon-business.svg": 282,
	"./icon-communication.svg": 283,
	"./icon-design.svg": 284,
	"./icon-environment.svg": 285,
	"./icon-event.svg": 286,
	"./icon-health.svg": 287,
	"./icon-humaniore.svg": 288,
	"./icon-music.svg": 289,
	"./icon-police.svg": 290,
	"./icon-science.svg": 291,
	"./icon-social-science.svg": 292,
	"./icon-teacher.svg": 293,
	"./img-arrow.svg": 294,
	"./img-box.svg": 295,
	"./instagram.svg": 296,
	"./line-small.svg": 297,
	"./line.svg": 298,
	"./logo-footer.svg": 299,
	"./logo-frontpage.svg": 300,
	"./logo.svg": 301,
	"./loop.svg": 302,
	"./mail.svg": 303,
	"./play.svg": 304,
	"./printer.svg": 305,
	"./quotes.svg": 306,
	"./square.svg": 307,
	"./wedge.svg": 308,
	"./youtube.svg": 309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;


//////////////////
// WEBPACK FOOTER
// ./svgs \.svg$
// module id = 47
// module chunks = 1